<template>
  <footer class="app-footer">
    <span class="app-footer__brand">Naprawa Online</span>
  </footer>
</template>

<script>
export default {
  name: "DetailsFooter",
};
</script>
